import React,{useState, useEffect} from "react";
import {data} from '../constants/data'
import './styles/home.css'


const Footer = () =>{

    const[email, setEmail] = useState("");
    const[loading, setLoading] = useState(false);
    const[message, setMessage] = useState("");

    const handleSubmit = (event) =>{
        event.preventDefault();
        console.log(email);
        setLoading(true);
        fetch('https://mailthis.to/sahiljena46@gmail.com',{
            email:email,
            _subject: 'Portfolio Form Submission',
            message: 'Hi, you have a email submission from '+email,
        }).then(function(data){
            setLoading(false);
            if(data.status === 400){
                setMessage("Something went wrong.")
            }
            return data.json();
        })
    }

    return(
        <footer className='flex font-bvp flex-col justify-center items-start max-w-2xl mx-auto w-full mb-8 px-4'>
            <div className="border border-blue-200 rounded p-6 my-4 w-full dark:border-gray-800 bg-blue-50 dark:bg-gray-900">
                <h5 className="text-lg md:text-xl font-bold text-gray-900 dark:text-gray-100">Up for a cool project? Let's discuss.</h5>
                <p className="my-1 text-gray-800 dark:text-gray-200">Drop your message and let's discuss.</p>
                <a href="https://wa.me/918178812482?text=I want to work on a project with you" className="mt-4 px-4 text-center w-full font-bold h-8 bg-green-400 dark:bg-green-400 text-gray-900 py-1 dark:text-gray-900 rounded" type="submit">Chat on WhatsApp</a>
                <div className="border border-gray-200 dark:border-gray-600 w-full my-8"></div>
                <p className="my-1 text-gray-800 dark:text-gray-200">Drop in your email ID and I will get back to you.</p>
                {message?<p className="mb-4 bg-red-400 text-white px-2 py-2 rounded text-xs">{message}</p>:<></>}
                <form className="relative my-4" onSubmit={handleSubmit}>
                    
                    <input onChange={(e)=>{setEmail(e.target.value)}} type="email" aria-label="Email for newsletter" placeholder="example@gmail.com" autoComplete="email" required="" className="px-4 py-2 mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full border-gray-300 rounded-md bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100" />
                    <button 
                        className={loading?`flex items-center justify-center absolute right-1 top-1 px-4 font-bold h-8 text-gray-900 dark:text-gray-100 rounded w-28 bg-gray-100 dark:bg-gray-500`:`flex items-center justify-center absolute right-1 top-1 px-4 font-bold h-8 text-gray-900 dark:text-gray-100 rounded w-28 bg-gray-100 dark:bg-gray-700`} 
                        type="submit">{loading?<>Sending...</>:<>Send</>}</button>
                </form>
                <p className="text-sm text-gray-800 dark:text-gray-200"></p>
            </div>
            <span className="text-gray-600">Spotify now playing :)</span>
            <img src='https://spotify-github-profile.vercel.app/api/view?uid=lerme04sk6zdt35pfweejygbi&cover_image=true&theme=novatorem&bar_color=b14ea4&bar_color_cover=true' alt='spotify' />
            <br />
            <div className='w-full max-w-2xl grid grid-cols-1 gap-4 pb-16 sm:grid-cols-3'>
                <div className='flex flex-col space-y-4'>
                    <a className='text-gray-500 hover:text-gray-600 transition hover:underline hover:decoration-dashed' href='/'>Home</a>
                    <a className='text-gray-500 hover:text-gray-600 transition hover:underline hover:decoration-dashed' href='/blog'>Blog</a>
                    <a className='text-gray-500 hover:text-gray-600 transition hover:underline hover:decoration-dashed' href='/projects'>Projects</a>
                    <a className='text-gray-500 hover:text-gray-600 transition hover:underline hover:decoration-dashed' href='/contact'>Contact</a>
                </div>
                <div className='flex flex-col space-y-4'>
                    <a className='text-gray-500 hover:text-gray-600 transition hover:underline hover:decoration-dashed' href={`https://github.com/${data.githubUsername}`} target='_blank' rel="noreferrer">Github</a>
                    <a className='text-gray-500 hover:text-gray-600 transition hover:underline hover:decoration-dashed' href={data.linkedin} target='_blank' rel="noreferrer">linkedIn</a>
                    <a className='text-gray-500 hover:text-gray-600 transition hover:underline hover:decoration-dashed' href={data.instagram} target='_blank' rel="noreferrer">Instagram</a>
                    <a className='text-gray-500 hover:text-gray-600 transition hover:underline hover:decoration-dashed' href={data.twitter} target='_blank' rel="noreferrer">Twitter</a>
                </div>
                <div className='flex flex-col space-y-4'>
                    <a className="text-gray-500 hover:text-gray-600 transition hover:underline hover:decoration-dashed" href={data.hackerrank} target='_blank' rel="noreferrer">Hackerrank</a>
                    <a className="text-gray-500 hover:text-gray-600 transition hover:underline hover:decoration-dashed" href={data.codechef} target='_blank' rel="noreferrer">Codechef</a>
                </div>
            </div>
        </footer>
    );
}

export default Footer